function slide(element) {
    var $element = element;
    var $parent = element.parents('.js-slide-parent');
    var $target = $parent.find('.js-slide-target');
    if(!$target.is(':visible')){
        $element.addClass('collapsed');
        $target.stop().slideDown();
    }else{
        $element.removeClass('collapsed');
        $target.stop().slideUp();
    }
}

function init() {
    if ($('.js-slide-click').length > 0) {
        $('.js-slide-click').click(function () {
            slide($(this));
        });
    }
}
$(function() {
    init();
});
